import moment from 'moment';
import { useState } from 'react';
import { regexTextSearch } from '../../../shared/utils/regexTextSearch';
import { ISearchParams } from '../../ui/components/SearchBar';
import { IContentCategoryEntry } from '../../../shared/api/contentful/types/IContentCategory';
import { IPressRelease } from '../../../shared/api/contentful/types/IPressRelease';
import { IBlogItem } from '../../../shared/api/contentful/types/IBlogItem';
import { INewsStory } from '../../../shared/api/contentful/types/INewsStory';
import {
	ALL_CATEGORIES,
	ContentCategory,
} from '../../../shared/domain/utils/getContentCategories';
import { ALL_YEARS, YearFilterValue } from './useAllYearsFilters';

type Klass<T = INewsStory | IPressRelease | IBlogItem> = {
	publicationDate?: string;
	title: string;
	category?: IContentCategoryEntry;
} & T;

export const useSearch = <T>(
	defaultYear: YearFilterValue,
	defaultCategory?: ContentCategory,
) => {
	const [searchParams, setSearchParams] = useState<ISearchParams | null>({
		year: defaultYear,
		category: defaultCategory,
		query: '',
	});

	const filterList = (list: Klass<T>[]) => {
		if (!searchParams) {
			return list;
		}
		return list.filter((item) => {
			const { category, year, query } = searchParams;
			const hasCategory =
				category === undefined ||
				(category && category.id === ALL_CATEGORIES) ||
				(item.category && item.category.id === category?.id);

			const publicationDate = item.publicationDate
				? new Date(item.publicationDate)
				: null;
			const isFromYear =
				year === ALL_YEARS ||
				!year ||
				publicationDate?.getFullYear().toString() === year;
			const hasQuery =
				!query ||
				regexTextSearch(
					`${item.title} ${moment(publicationDate).format('Do MMMM YYYY')}`,
					query,
				);
			return hasCategory && isFromYear && hasQuery;
		});
	};

	return { searchParams, setSearchParams, filterList };
};
